import { useEffect } from 'react';

/**
 * Sets document title, meta description, and optional JSON-LD structured data.
 * @param {{ title: string, description?: string, jsonLd?: object }} options
 */
export function useSEO({ title, description, jsonLd }) {
  useEffect(() => {
    // Set document title
    document.title = title;

    // Set or update meta description
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (meta) {
        meta.setAttribute('content', description);
      } else {
        meta = document.createElement('meta');
        meta.name = 'description';
        meta.content = description;
        document.head.appendChild(meta);
      }
    }

    // Inject JSON-LD structured data
    let scriptEl;
    if (jsonLd) {
      scriptEl = document.createElement('script');
      scriptEl.type = 'application/ld+json';
      scriptEl.text = JSON.stringify(jsonLd);
      document.head.appendChild(scriptEl);
    }

    return () => {
      if (scriptEl) {
        document.head.removeChild(scriptEl);
      }
    };
  }, [title, description, jsonLd]);
}
